import { render, staticRenderFns } from "./adticket.vue?vue&type=template&id=2ebb17c5&scoped=true"
import script from "./adticket.vue?vue&type=script&lang=js"
export * from "./adticket.vue?vue&type=script&lang=js"
import style0 from "./adticket.vue?vue&type=style&index=0&id=2ebb17c5&prod&lang=scss&scoped=true"
import style1 from "./adticket.vue?vue&type=style&index=1&id=2ebb17c5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebb17c5",
  null
  
)

export default component.exports